import { Tooltip } from 'react-tooltip';

/**
 * Tooltip unico della chat (WhatsApp, Instagram, Messenger, Team, pannello AI).
 * I pulsanti usano data-tooltip-id={CHAT_TIP} e data-tooltip-content="...":
 * niente `title` nativo, che arriva in ritardo e non si vede sui dispositivi touch.
 */
export const CHAT_TIP = 'chat-tip';

export function ChatTooltip() {
  return (
    <Tooltip
      id={CHAT_TIP}
      delayShow={250}
      className="!text-xs !px-2.5 !py-1.5 !rounded-md !z-[10000] !max-w-xs"
    />
  );
}

type TipPlace = 'top' | 'bottom' | 'left' | 'right';

/**
 * Attributi pronti da spargere su un elemento: {...tip('Allega file')}.
 * Con `{ label: true }` imposta anche aria-label: serve ai pulsanti con la sola
 * icona, che altrimenti per un lettore di schermo non hanno nome. Sui pulsanti
 * con testo visibile NON va usato: aria-label sostituirebbe quel testo.
 */
export function tip(
  content: string | null | undefined | false,
  place: TipPlace = 'top',
  options?: { label?: boolean },
) {
  if (!content) return {};
  const base = { 'data-tooltip-id': CHAT_TIP, 'data-tooltip-content': content, 'data-tooltip-place': place } as const;
  return options?.label ? { ...base, 'aria-label': content } : base;
}

/** Come tip(), per i pulsanti con la sola icona: aggiunge anche aria-label. */
export function iconTip(content: string | null | undefined | false, place: TipPlace = 'top') {
  return tip(content, place, { label: true });
}
